<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>活动信息</el-breadcrumb-item>
			<el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage">活动复盘</span></el-breadcrumb-item>
			<el-breadcrumb-item v-if="isShowDetail">复盘详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div v-if="!isShowDetail" class="page-content">
			<section class="seaerch-wrapper">
				<el-form class="search-form" style="margin-left: -30px;">
					<el-form-item label="活动主题：" :label-width="formLabelWidth">
						<el-input clearable size="small" v-model="search.theme" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="活动单号：" :label-width="formLabelWidth">
						<el-input size="small" v-model="search.activity_number" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="结束时间：" :label-width="formLabelWidth">
					<el-date-picker
						 size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="time"
							type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"
							style="width: 100%;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="平台：" :label-width="formLabelWidth">
						<el-select size="small" clearable v-model="search.platform" placeholder="全部">
							<el-option v-for="item in plateList" :key="item.dictCode" :value="item.dictCode"
								:label="item.dictName">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="店铺名称：" :label-width="formLabelWidth">
						<el-input size="small" v-model="search.shopname" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item :label-width="formLabelWidth">
						<el-button size="small" class="search-btn" plain @click="loadAll(true)">查询</el-button>
					</el-form-item>
				</el-form>
			</section>
			<div class="tabs">
				<el-tabs v-model="activeName" @tab-click="onTabsClick" type="card">
					<el-tab-pane v-for="(item, index) in getActivityReviewCount" :key="index" :label="item.label"
						:name="item.name">
						<el-table :data="getActivityReview.content" style="width: 100%" @row-click="onOpenDrawer">
							<el-table-column prop="campaign_name" label="活动主题" width="260">
							</el-table-column>
							<el-table-column prop="activity_number" label="活动单号">
							</el-table-column>
							<el-table-column label="店铺名称" width="260">
								<template slot-scope="scope">
									<div style="display:flex;align-items:center">
										<span>{{ scope.row.shop_name }}</span>
										<Shopname style="margin-left:10px" :platform="scope.row.dict_code" />
									</div>
								</template>
							</el-table-column>
							<el-table-column label="活动结束时间" width="200">
								<template slot-scope="scope">
									<span>{{ scope.row.end_time | fullTime }}</span>
								</template>
							</el-table-column>
							<el-table-column label="合计条数">
								<template slot-scope="scope">
									<span> 合计:{{ scope.row.linknumber }}条</span>
								</template>
							</el-table-column>
							<el-table-column sortable width="150" label="活动状态">
								<template slot-scope="scope">
									<div style="display:flex;align-items:center"
										v-if="scope.row.ctivitychecking === '1'">
										<i style="color:#21D844;" class="el-icon-success"></i>
										<span style="color:#606266">活动已复盘</span>
									</div>
									<div style="display:flex;align-items:center" v-else>
										<i style="color:#FFA937;" class="el-icon-info"></i>
										<span style="color:#606266">活动待复盘</span>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<Pagination v-if="item.value" class="pagination" :total="item.value" v-model="pagination"
							@onChange='load' />
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div v-if="isShowDetail" style="margin: 20px;">
			<div>
				<el-card class="drawer-content-card">
					<el-row>
						<el-col :span="12">
							<span class="activity-theme" style="font-size: 20px;font-weight: bold;">{{
								getActivityReviewDetail.details.shop_name }}</span>
							<span class="activity-shop" style="padding-left: 150px;">{{
								getActivityReviewDetail.details.platform_code | platformChinese}}</span>
						</el-col>
						<el-col :span="12">
							<span v-if="getActivityReviewDetail.details.ctivitychecking === '1'"
								style="float: right;clear: both;">
								<i class="el-icon-success" style="color: #3CC432;"></i><span
									class="drawer-approval-text" style="display: inline-block;">活动已复盘</span>
							</span>
							<span v-else style="float: right;clear: both;">
								<i class="el-icon-info" style="color: #FFA937;"></i><span class="drawer-approval-text"
									style="display: inline-block;">活动待复盘</span>
							</span>
						</el-col>
						<el-col :span="12" style="color: white;">
							1
						</el-col>
						<el-col :span="12" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								活动主题：
							</span>
							{{ getActivityReviewDetail.details.campaign_name }}
						</el-col>

						<el-col :span="12" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								申报方式：
							</span>
							{{ getActivityReviewDetail.details.campaignway === 0 ? '按产品申报' : data.campaignway === 0 ?
								'按链接申报' :
							'全店铺申报' }}
						</el-col>

						<el-col :span="12" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								活动单号：
							</span>
							{{ getActivityReviewDetail.details.activity_number }}
						</el-col>

						<el-col :span="12" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								提交时间：
							</span>
							{{ getActivityReviewDetail.details.createtime | fullTime }}
						</el-col>

						<el-col :span="12" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								预热时间：
							</span>
							{{ getActivityReviewDetail.details.preheating_time ?
								(getActivityReviewDetail.details.preheating_time | fullTime) : '' }}
						</el-col>

						<el-col :span="12" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								活动时间：
							</span>
							{{ getActivityReviewDetail.details.start_time | fullTime }} ~ {{
								getActivityReviewDetail.details.end_time | fullTime }}
						</el-col>

						<el-col :span="24" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								活动说明：
							</span>
							{{ isDealer ? getActivityReviewDetail.details.campaign_desc :
								getActivityReviewDetail.list[0].activitysummarized }}
						</el-col>

						<el-col :span="24" style="padding: 4px 0;">
							<span class="drawer-card-key positon-right-text">
								附件：
							</span>
							<span v-if="getActivityReviewDetail.details.attachment">
								<span
									v-for="(item, i) in hanldeAttachmentName(isDealer ? undefined : getActivityReviewDetail.list[0].reviewfile)"
									:key="i">
									<span>{{ item }}</span>
									&nbsp;
									<i @click="onDownFile(isDealer ? getActivityReviewDetail.details.attachment.split(',')[i] : getActivityReviewDetail.details.attachment.split(',')[0])"
										class="el-icon-download" style="cursor:pointer;color:#69B6F4 "></i>
								</span>
							</span>
						</el-col>
					</el-row>

				</el-card>
				<template v-if="getActivityReviewDetail.details.campaignway !== 2">
					<el-card style="margin-top:10px" v-for="(item, index) in getActivityReviewDetail.list" :key="index">
						<el-row>
							<el-col :span="12" style="padding: 4px 0;">
								<span class="drawer-card-key positon-right-text">
									产品名称：
								</span>
								{{ item.product_info }}
							</el-col>
							<el-col :span="12" style="padding: 4px 0;">
								<span class="drawer-card-key positon-right-text">
									活动链接：
								</span>
								<el-link @click="onOpenWindow(item.product_url)" class="activity-link"
									:underline="false" type="primary">{{ item.product_url }}</el-link>
							</el-col>
						</el-row>
						<el-row>
							<div v-for="(i, k) in approvalFields[index]" :key="k">
								<el-col :span="12" style="padding: 4px 0;">
									<span class="drawer-card-key positon-right-text">
										{{ i.label }}：
									</span>
									{{ i.value }}
								</el-col>
							</div>
						</el-row>
						<el-row v-if="getActivityReviewDetail.details.ctivitychecking === '1'">
							<div v-for="(i, k) in reviewFields[index]" :key="k">
								<el-col :span="12" style="padding: 4px 0;">
									<span class="drawer-card-key positon-right-text">
										{{ i.label }}：
									</span>
									{{ i.value }}
								</el-col>
							</div>
						</el-row>
						<el-row class="position-top" v-if="getActivityReviewDetail.details.ctivitychecking === '0'"
							style="border-top: 1px solid #DCDFE6;">
							<div class="position-top" v-for="(r, kk) in reviewFields[index]" :key="kk">
								<el-col :span="12" style="padding: 4px 0;">
									<span class="positon-right-text" style="width:150px;text-align:center;">
										<span style="color: red">*</span>
										<span>{{ r.label }}：</span>
									</span>
									<el-input size="small" @input="onInputBlur" v-if="r.isNumberField" type="number"
										style="width: 200px" v-model="r['value' + ':' + index + kk]"
										placeholder="请输入内容">
									</el-input>
									<el-input size="small" @input="onInputBlur" style="width: 200px" v-else
										v-model.trim="r['value' + ':' + index + kk]" placeholder="请输入内容">
									</el-input>
								</el-col>
							</div>
						</el-row>
					</el-card>
				</template>
				<div style="background-color: white;padding: 20px;margin-top: 8px;">
					<div v-if="getActivityReviewDetail.details.ctivitychecking === '0'">
						<el-row class="position-top">
							<el-col class="activity-summary positon-right-text" :span="2">
								<span style="color: red">*</span>
								<span>活动总结:</span>
							</el-col>
							<el-col :span="20">
								<el-input size="small" style="width:425px" type="textarea" rows="4" show-word-limit
									maxlength="200" placeholder="请输入不多于200字的活动说明" v-model.trim="activityDesc">
								</el-input>
							</el-col>
						</el-row>
						<el-row class="position-top">
							<el-col class="activity-summary positon-right-text" :span="2">
								<span>附件:</span>
							</el-col>
							<el-col :span="20">
								<el-upload class="upload-demo" name="file" :with-credentials="true"
									action="/hcm/hcmWorkOrder/headUpload" :on-preview="handlePreview"
									:on-remove="handleRemove" :on-success="handleUploadSuccess"
									:before-upload="beforeUpload" multiple :file-list="fileList" :data="uploadType">
									<el-button size="small" plain><i
											class="el-icon-upload el-icon--right"></i>点击上传</el-button>
									<div slot="tip" style="color:#999" class="el-upload__tip">
										支持拓展名: .rar .zip .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg .png格式,附件单个上传大小限制50M
									</div>
								</el-upload>
							</el-col>
						</el-row>
					</div>
					<div v-if="getActivityReviewDetail.details.ctivitychecking === '0'" style="margin-top: 10px">
						<el-button size="small" type="primary" @click="onCommitForm">提交</el-button>
						<el-button size="small" @click="isShowDetail = false">取消</el-button>
					</div>
					<div style="padding-left: 20px" v-if="getActivityReviewDetail.details.ctivitychecking === '1'">
						<el-row class="position-top">
							<el-col :span="24">
								<span class="drawer-card-key positon-right-text">
									活动总结：
								</span>
								{{ isDealer ? getActivityReviewDetail.list[0].activitysummarized :
									getActivityReviewDetail.details.campaign_desc }}
							</el-col>
						</el-row>
						<el-row class="position-top">
							<el-col :span="24">
								<span class="drawer-card-key positon-right-text">
									附件：
								</span>
								<span v-if="getActivityReviewDetail.list[0].reviewfile">
									<span
										v-for="(item, i) in hanldeAttachmentName(getActivityReviewDetail.list[0].reviewfile)"
										:key="i">
										<span>{{ item }}</span>
										&nbsp;
										<i @click="onDownFile(isDealer ? getActivityReviewDetail.list[0].reviewfile.split(',')[i] : getActivityReviewDetail.list[0].reviewfile.split(',')[0])"
											class="el-icon-download" style="cursor:pointer;color:#69B6F4">
										</i>
									</span>
								</span>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'components/pagination/pagination'
import Shopname from 'components/shopname/Shopname'
import { getSinceThreeMonth } from '@/libs/date'
export default {
	name: 'ActivityDetails',

	components: {
		Pagination,
		Shopname
	},

	data() {
		return {
			uploadType: {
				tong: 'activityReview'
			},
			formLabelWidth: '100px',
			isDealer: false,
			time: [],
			input: '',
			approvalFields: [],
			reviewFields: [],
			fileList: [],
			uploadFileList: [],
			activityDesc: '',
			data: {},
			checkboxData: [],
			checkList: [],
			search: {},
			isShowDetail: false,
			showDialog: false,
			pagination: {
				size: 10,
				current: 1
			},
			breadcrumbArray: ['活动信息', '活动审批'],
			activeName: '全部',
		}
	},

	methods: {
		hanldeAttachmentName(attach) {
			let attachment;
			if (attach) {
				attachment = attach;
			} else {
				attachment = this.getActivityReviewDetail.details.attachment;
			}
			let attachmentArr = attachment.split(',');
			let res = attachmentArr.map(item => {
				return item.substring(item.indexOf("_") + 1);
			})
			return res;
		},
		onDownFile(file) {
			let url = `hcm/hcmWorkOrder/downLoadFile?filename=${file}`
			this.onOpenWindow(url);
		},
		onInputBlur() {
			this.$forceUpdate();
		},
		handleUploadSuccess(res) {
			this.uploadFileList.push(res.data.data);
		},
		beforeUpload(file) {
			let name = file.name;
			let p = /\.(jpg|rar|zip|doc|docx|xls|xlsx|ppt|pptx|pdf|png)$/
			if (!p.test(name)) {
				this.$message({
					showClose: true,
					message: '请上传符合要求格式的文件',
					type: 'warning'
				});
			}
			let limitSize = 1 * 1024 * 1024 * 50;
			if (file.size > limitSize) {
				this.$message({
					showClose: true,
					message: '请上传大小小于50M的文件',
					type: 'warning'
				});
			}
			if (p.test(name) && file.size < limitSize) {
				return true;
			}
			return false;

		},
		handleData() {
			let data = [];
			let list = this.getActivityReviewDetail.list;
			for (let i = 0; i < this.reviewFields.length; i++) {
				let obj = {};
				let add_field = {};
				for (let j = 0; j < this.reviewFields[i].length; j++) {
					let fieldObj = this.reviewFields[i];
					if (!fieldObj[j]['value' + ':' + i + j] && fieldObj[j]['value' + ':' + i + j] !== 0) {
						this.$message({
							showClose: true,
							message: '请填写必填信息',
							type: 'warning'
						});
						return []
					}
					if (fieldObj[j].field === "actualsales") {
						obj.actualsales = fieldObj[j]['value' + ':' + i + j];
					}
					if (fieldObj[j].field === "salesnumber") {
						obj.salesnumber = fieldObj[j]['value' + ':' + i + j];
					}
					if (fieldObj[j].field !== "salesnumber" && fieldObj[j].field !== "actualsales") {
						add_field[fieldObj[j].field] = fieldObj[j]['value' + ':' + i + j];
					}

				}
				if (!this.activityDesc) {
					this.$message({
						showClose: true,
						message: '请填写活动总结',
						type: 'warning'
					});
					return
				} else {
					obj.activitysummarized = this.activityDesc;
				}
				if (this.uploadFileList.length) {
					obj.reviewfile = this.uploadFileList.join(",");
				}
				obj.camproid = list[i].id;
				obj.add_field = add_field;
				data.push(obj);
			}
			return data;
		},
		onCommitForm() {
			let data = this.handleData();
			if (data.length) {
				fetch({
					url: "hcm/campgign/insertReviewByList",
					method: "post",
					data: JSON.stringify(data),
					headers: {
						'Content-Type': 'application/json',
					},
					noFormat: false,
					responseType: "json"
				}).then((res) => {
					if (res.status === '10000') {
						this.isShowDetail = false;
						this.$message({
							showClose: true,
							message: '提交成功',
							type: 'success'
						});
						this.loadAll();
					}
				})
			}
		},
		handleRemove(file, fileList) {
			let res = [];
			for (let i of fileList) {
				res.push(i.response.data.data);
			}
			this.uploadFileList = res;
		},
		handlePreview(file) {
			console.log(file);
		},
		onOpenWindow(url) {
			window.open(url)
		},
		onChangePage() {
			if (this.isShowDetail) {
				this.isShowDetail = !this.isShowDetail;
			}
		},
		...mapActions([
			'reqPlateList',
			'reqActivityReview',
			'reqActivitySetting',
			'reqActivityReviewDetail',
			'reqActivityReviewCount',
			'reqActivityReviewSetting',
			'reqActivityAddReview'
		]),
		onCloseDailog() {
			this.showDialog = false;
		},
		onOpenDrawer(row) {
			let params = {
				id: row.id
			}
			this.reqActivityReviewDetail(params).then(() => {
				this.initReviewDetailData();
			})
		},
		initReviewDetailData() {
			this.uploadFileList = [];
			// 获取活动审批设置的字段数据
			this.reqActivitySetting().then(data => {
				for (let i = 0; i < this.getActivityReviewDetail.list.length; i++) {
					this.approvalFields[i] = this.getApprovalCustomFieldArray(data, this.getActivityReviewDetail.list[i]);
				}
				console.log(this.approvalFields);

				this.reqActivityReviewSetting().then(data => {
					if (this.getActivityReviewDetail.details.ctivitychecking === '1') {
						for (let i = 0; i < this.getActivityReviewDetail.list.length; i++) {
							this.reviewFields[i] = this.getReviewFieldArray(data, this.getActivityReviewDetail.list[i]);
						}
					} else {
						for (let i = 0; i < this.getActivityReviewDetail.list.length; i++) {
							this.reviewFields[i] = this.getReviewCustomFieldArray(data);
						}
					}
					console.log(this.reviewFields);

					this.isShowDetail = true;
				})
			})
		},
		getReviewFieldArray(setting, reviewItem) {
			let res = [];
			if (reviewItem['salesnumber']) {
				let obj = {};
				obj.value = reviewItem['salesnumber'];
				obj.label = '实际销售量';
				// obj.needShowLowPriceTag = true;
				obj.field = 'salesnumber';
				res.push(obj);
			}
			if (reviewItem['actualsales']) {
				let obj = {};
				obj.value = reviewItem['actualsales'];
				obj.label = '实际销售额';
				// obj.needShowLowPriceTag = true;
				obj.field = 'actualsales';
				res.push(obj);
			}
			if (reviewItem.reviewfield && reviewItem.reviewfield !== '{}') {
				let reviewfield = JSON.parse(reviewItem.reviewfield);
				for (let i in reviewfield) {
					for (let j in setting) {
						for (let k of setting[j].data) {
							if (k.fieldvalue === i) {
								let obj = {};
								obj.value = reviewfield[i];
								obj.label = k.fieldname;
								res.push(obj);
							}

						}
					}
				}
			}
			return res
		},
		getApprovalCustomFieldArray(setting, reviewItem) {
			let res = [];
			console.log(reviewItem);

			if (reviewItem['apply_price']) {
				let obj = {};
				obj.value = reviewItem['apply_price'];
				obj.label = '申请标价';
				obj.needShowLowPriceTag = true;
				obj.field = 'apply_price';
				res.push(obj);
			}
			if (reviewItem['actual_price']) {
				let obj = {};
				obj.value = reviewItem['actual_price'];
				obj.label = '实际成交价';
				obj.needShowLowPriceTag = true;
				obj.field = 'actual_price';
				res.push(obj);
			}
			if (reviewItem['estimated_sales']) {
				let obj = {};
				obj.value = reviewItem['estimated_sales'];
				obj.label = '预计销售额';
				res.push(obj);
			}
			if (reviewItem['sales']) {
				let obj = {};
				obj.value = reviewItem['sales'];
				obj.label = '预计销量';
				res.push(obj);
			}
			if (reviewItem.add_field && reviewItem.add_field !== '{}') {
				let addField = JSON.parse(reviewItem.add_field);
				for (let i in addField) {
					for (let j in setting) {
						for (let k of setting[j].data) {
							if (k.fieldvalue === i) {
								let obj = {};
								obj.value = addField[i];
								obj.label = k.fieldname;
								res.push(obj);
							}

						}
					}
				}
			}
			return res;
		},
		getReviewCustomFieldArray(data) {
			let res = [];
			for (let i in data) {
				for (let j of data[i].data) {
					let obj = {};
					if (j.isChecked === 1) {
						if (data[i].title === '价格字段') {
							obj.isNumberField = true;
						} else {
							obj.isNumberField = false;
						}
						obj.label = j.fieldname;
						obj.field = j.fieldvalue;
						res.push(obj);
					}
				}
			}
			return res;
		},
		loadAll(isSearch) {
			this.load(isSearch);
			this.loadCount();
		},
		loadCount() {
			let params = {
				begintime: this.time[0],
				endtime: this.time[1],
				campaign_name: this.search.theme,
				shop_name: this.search.shopname,
				platform_code: this.search.platform,
				activity_number: this.search.activity_number
			}

			for (let i in params) {
				if (params[i] === "") {
					delete params[i];
				}
			}

			this.reqActivityReviewCount(params);
		},
		load(isSearch) {
			this.pagination.current = isSearch ? 1 : this.pagination.current;
			let params = {
				pageNo: this.pagination.current,
				pageSize: this.pagination.size,
				begintime: this.time[0],
				endtime: this.time[1],
				campaign_name: this.search.theme,
				shop_name: this.search.shopname,
				platform_code: this.search.platform,
				ctivitychecking: this.search.ctivitychecking
			}

			for (let i in params) {
				if (params[i] === "") {
					delete params[i];
				}
			}

			this.reqActivityReview(params);
		},
		onTabsClick(tab) {
			tab.index === '0' ? this.search.ctivitychecking = "" : tab.index === '1' ? this.search.ctivitychecking = "0" : this.search.ctivitychecking = "1"
			this.load();
		},
	},

	computed: {
		...mapGetters([
			"plateList",
			"getActivityReview",
			"getActivityReviewCount",
			'getUserLoginType',
			"getActivityReviewDetail"
		]),
	},

	created() {
		this.time = getSinceThreeMonth();
		this.loadAll();
		if (this.getUserLoginType === 'DEALER') {
			this.isDealer = true;
		}

		this.isDealer && this.reqPlateList();
	},

	mounted() { },
}
</script>


<style lang='scss'>
.g-margin-left {
	display: inline-block;
	margin-left: 10px;
}

@import "style/activityApproval.scss";
@import "style/activityDetails.scss";

.breadcrumb-box .el-breadcrumb__item:last-child .el-breadcrumb__inner {
	font-weight: bold;
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.breadcrumb-box {
	display: flex;
	align-items: center;
	width: 100%;
	height: 40px;
	background-color: #fff;
	padding-left: 20px;
}
</style>
